import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-lu",
  "use": "icon-flag-lu-usage",
  "viewBox": "0 0 1542 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1542 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-lu\"><defs><style type=\"text/css\"></style></defs><path d=\"M7.547912 1017.710074h1520.904176V6.289926H7.547912v1011.420148z m1523.420147 3.773955v-3.773955 3.773955zM1.257985 1024V0H1534.742015v1024H1.257985z\" fill=\"#353636\" p-id=\"2483\" /><path d=\"M3.773956 681.82801h1527.194103v339.656019H3.773956z\" fill=\"#009CE1\" p-id=\"2484\" /><path d=\"M3.773956 342.17199h1527.194103v339.65602H3.773956z\" fill=\"#FFFFFF\" p-id=\"2485\" /><path d=\"M3.773956 2.515971h1527.194103v339.656019H3.773956z\" fill=\"#E35F48\" p-id=\"2486\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-lu.svg
// module id = OCMx
// module chunks = 24